module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.ttf
// module id = 1568
// module chunks = 6